import type { EditorState } from '@xsscool/shared';

export type PayloadStatus = 'pending' | 'public' | 'rejected';

export interface PayloadEntry {
  id: string;
  title: string;
  description: string;
  tags: string[];
  status: PayloadStatus;
  alias: string | null;
  state: EditorState;
  createdAt: number;
  updatedAt: number;
  reviewedAt: number | null;
}

export async function listPublicPayloads(): Promise<PayloadEntry[]> {
  const res = await fetch('/api/payloads', { credentials: 'include' });
  if (!res.ok) return [];
  const data = (await res.json()) as { payloads: PayloadEntry[] };
  return data.payloads;
}

export async function listMyPayloads(): Promise<PayloadEntry[]> {
  const res = await fetch('/api/payloads/mine', { credentials: 'include' });
  if (!res.ok) return [];
  const data = (await res.json()) as { payloads: PayloadEntry[] };
  return data.payloads;
}

export interface SubmitPayloadInput {
  title: string;
  description: string;
  tags?: string;
  alias?: string;
  state: EditorState;
}

export async function submitPayload(
  input: SubmitPayloadInput,
): Promise<{ id: string; status: PayloadStatus }> {
  const res = await fetch('/api/payloads', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`submit failed: ${res.status} ${text}`);
  }
  return (await res.json()) as { id: string; status: PayloadStatus };
}

export async function deleteMyPayload(id: string): Promise<void> {
  await fetch(`/api/payloads/${id}`, { method: 'DELETE', credentials: 'include' });
}
